import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroTrajesMedida from './components/HeroTrajesMedida';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ProcessSection from './components/ProcessSection';
import FAQSection from './components/FAQSection';
import BookingCalendar from './components/BookingCalendar';
import CTASection from './components/CTASection';
import { useSEO } from '../../hooks/useSEO';
import { SchemaMarkup } from '../../components/SEOHead';

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Trajes a Medida Alta Costura Barcelona',
  provider: {
    '@type': 'LocalBusiness',
    name: 'Anthony Sánchez Couture',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Rambla de Catalunya, 85, Principal - 2',
      addressLocality: 'Barcelona',
      addressRegion: 'Cataluña',
      postalCode: '08008',
      addressCountry: 'ES',
    },
  },
  areaServed: {
    '@type': 'City',
    name: 'Barcelona',
  },
  description: 'Diseño y confección de trajes, smoking y chaqués a medida en Barcelona. Sastrería de alta costura artesanal para el hombre exigente.',
  serviceType: 'Trajes a Medida Alta Costura',
  priceRange: '€€€€',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '¿Cuánto tiempo tarda la confección de un traje a medida?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Recomendamos reservar con al menos 4-6 meses de antelación para trajes de alta costura.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Cuál es el precio de un traje a medida de alta costura?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Nuestros trajes a medida parten desde 3.800€. El precio final depende del diseño y los tejidos seleccionados.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Qué tejidos utilizan para los trajes?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Trabajamos con las mejores lanas italianas y británicas, sedas naturales para forros y cachemire para chaquetas especiales.',
      },
    },
  ],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: 'https://anthonysanchezc.com',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Trajes a Medida',
      item: 'https://anthonysanchezc.com/trajes-medida',
    },
  ],
};

export default function TrajesMedida() {
  useSEO({
    title: 'Trajes a Medida Barcelona | Alta Costura Masculina | Anthony Sánchez Couture',
    description: 'Trajes, smoking y chaqués artesanales a medida en Barcelona. Sastrería de alta costura con tejidos de lujo. Reserva cita privada en el Eixample.',
    keywords: 'trajes a medida Barcelona, sastrería alta costura, trajes hombre Barcelona, smoking a medida, chaqués Barcelona, sastre Barcelona, Eixample',
    canonical: '/trajes-medida',
    ogTitle: 'Trajes a Medida Barcelona — Alta Costura Masculina',
    ogDescription: 'Diseñamos trajes, smoking y chaqués únicos en Barcelona. Sastrería artesanal de alta costura para el hombre exigente.',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={serviceSchema} />
      <SchemaMarkup schema={faqSchema} />
      <SchemaMarkup schema={breadcrumbSchema} />
      <Navbar />
      <main>
        <HeroTrajesMedida />
        <ServicesSection />
        <ProcessSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
        <BookingCalendar />
      </main>
      <Footer />
    </div>
  );
}